import { JstType } from '../../models/jobModels/jstType';
import { JstNumerical, JstSubmission } from '../../models/inputTypes/JstFields';
import { InputFile } from '../../models/jobModels/ModelsFileTypes';
import { prepareSimsFiles } from '../functions/jstFilePreparation';

export const jstPreparation = (numerical: JstNumerical, submission: JstSubmission): JstType => {
  const preparedInputFiles: Partial<InputFile>[] = prepareSimsFiles(numerical.simsFiles, numerical.project);

  return {
    simulation: 'jst',
    project: numerical.project,
    name: submission.simulationFile,
    parameters: {
      input_file: preparedInputFiles,
    },
  };
};
